import { closeIcon, lucidTagsIcon } from '@g99-product-web-ui/shared-util-lib';

/**
 * SVG Icons for UTM Input Component
 */
export const UTM_INPUT_SVG_ICONS = {
  tag: lucidTagsIcon,

  close: closeIcon,
};

/**
 * Default UTM parameter suggestions
 */
export const DEFAULT_UTM_SUGGESTIONS = [
  { type: 'source', value: 'google' },
  { type: 'source', value: 'facebook' },
  { type: 'source', value: 'instagram' },
  { type: 'medium', value: 'cpc' },
  { type: 'medium', value: 'email' },
  { type: 'campaign', value: 'summer_sale' },
];

/**
 * Mapping from API field names to UTM types
 */
export const UTM_FIELD_MAPPING: Record<string, string> = {
  utmSources: 'source',
  utmMediums: 'medium',
  utmCampaigns: 'campaign',
  utmTerms: 'term',
  utmContents: 'content',
};

/**
 * Mapping from UTM types to API field names
 */
export const UTM_TYPE_MAPPING: Record<string, string> = {
  source: 'utmSources',
  medium: 'utmMediums',
  campaign: 'utmCampaigns',
  term: 'utmTerms',
  content: 'utmContents',
};

/**
 * Color classes for different UTM parameter types
 */
export const UTM_TYPE_COLOR_MAP: Record<string, string> = {
  source: 'tag-blue',
  medium: 'tag-purple',
  campaign: 'tag-green',
  term: 'tag-orange',
  content: 'tag-pink',
};
